import { Box, Grid, Typography } from "@mui/material";
import AspectRatio from "@mui/joy/AspectRatio";
import data from "./../../Assets/data/dashboard.json";

const DashboardSection = () => {
  return (
    <>
      <Box
        style={{
          // background: "#003366",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "2em",
          paddingBottom: "2em",
        }}
      >
        <Box style={{ maxWidth: "960px", width: "100%" }}>
          <Grid container>
            <Grid xs={12} item>
              <Typography fontSize="28px" fontWeight={600}>
                DASHBOARDS
              </Typography>
            </Grid>
            {data.map((dashboard, i) => {
              return (
                <Grid item xs={4} key={i}>
                  <Box
                    style={{
                      paddingBottom: "16px",
                      margin: "16px",
                      boxShadow: "10px 10px 20px rgba(0, 0, 0, 0.25)",
                    }}
                  >
                    <AspectRatio>
                      <img
                        src={
                          process.env.PUBLIC_URL +
                          "/Images/Dashboards/" +
                          dashboard.image
                        }
                        alt="dashboard"
                        width="100%"
                      />
                    </AspectRatio>
                    <Typography style={{ padding: "12px" }} fontWeight={600}>
                      {dashboard.title}
                    </Typography>
                  </Box>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Box>
    </>
  );
};

export default DashboardSection;
